import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faTag } from '@fortawesome/pro-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';
import { RaaRoles } from '../../../../utility/SecurityRules';
import { selectSingleAlert } from '../../../../redux/slices/singleAlertSlice/singleAlertSlice';
import EditableTextField from '../../../common/EditableTextField/EditableTextField';
import { alertDetailsModalTypes } from '../../../../utility/alertDetailsModalTypes';
import useFavoriteSingleAlert from '../useFavoriteSingleAlert';
import useHandleSubmitAlertDescription from './useHandleSubmitAlertDescription';
import { selectAllTagsByTagIdList } from '../../../../redux/slices/tagListSlice/tagListSlice';
import { loadAlertForClone } from '../../../../redux/slices/alertFormSlice/alertFormSlice';

/* istanbul ignore next */
function AlertDetailsReportHeader(props) {
  const {
    dispatchModal,
  } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { toggleFavoriteAlert } = useFavoriteSingleAlert();
  const { handleSubmitDescription } = useHandleSubmitAlertDescription();
  const alert = useSelector(selectSingleAlert);
  const tags = useSelector((state) => selectAllTagsByTagIdList(state, alert.tagIds));

  const onClone = async () => {
    await dispatch(loadAlertForClone({ alertId: alert.id }));
    history.push('/s/alerts/new');
  };

  const DescriptionComponent = () => <span>{alert.description}</span>;
  // eslint-disable-next-line react/prop-types
  const genericDropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      href=""
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      ref={ref}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </div>
  ));

  return (
    <>
      <div className="clearfix">
        <div className="float-left">

          <div className="row">
            <div className="col">
              <h4 className="my-0">
                <HasRolePrivileges
                  targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}
                  alternativeComponent={<DescriptionComponent description={alert.description} />}
                >
                  <EditableTextField
                    originalTitle={alert.description}
                    userHasTitleEditPrivileges
                    saveTitle={handleSubmitDescription}
                  />
                </HasRolePrivileges>
              </h4>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col mx-3">
              {tags.length > 0 && (
                <div>
                  <FontAwesomeIcon icon={faTag} className="mr-2" />
                  {tags.map((tag) => tag.name).join(', ')}
                </div>
              )}
            </div>
          </div>
        </div>

        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}
        >
          <div className="float-right">
            <div className="row">
              <div className="col p-0">
                <button
                  type="button"
                  className="btn btn-sm btn-light border-1 mx-1"
                  style={{ borderColor: '#ccc' }}
                  onClick={() => {
                    history.push(`/s/alerts/${alert.id}/edit`);
                  }}
                >
                  Edit
                </button>
              </div>
              <div className="col mt-1 pl-0">
                <Dropdown>
                  <Dropdown.Toggle as={genericDropdownToggle}>
                    <span className="m-3"><FontAwesomeIcon icon={faEllipsisV} size="lg" /></span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="right">
                    <Dropdown.Item
                      onClick={() => onClone(alert.id)}
                    >
                      <Icon icon="copy" className="mr-lg-1" />
                      <span className="d-none d-lg-inline-block">
                        Clone
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => dispatchModal(alertDetailsModalTypes.DELETE_ALERT)}
                    >
                      <Icon icon="trash" className="mr-lg-1" />
                      <span className="d-none d-lg-inline-block">
                        Delete
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => toggleFavoriteAlert(alert.id)}>
                      <Icon icon="star" className="mr-lg-1" />
                      <span className="d-none d-lg-inline-block">
                        {alert.isFavorite ? 'Unfavorite' : 'Favorite'}
                      </span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

              </div>
            </div>

          </div>
        </HasRolePrivileges>
      </div>
    </>
  );
}

AlertDetailsReportHeader.propTypes = {
  dispatchModal: PropTypes.func.isRequired,
};

export default AlertDetailsReportHeader;
